import _BaseController from 'Controllers/Web/_BaseController';
import ListController from 'Vue/Web/Shop/Course/ListController.vue';

global.Controller = new class extends _BaseController {
	ListControllerVue?: Vue;

    ready() {
        super.ready();

			/* 初始vue */
			this.ListControllerVue = new Vue({
				...ListController,
				el: '.class-content',
				propsData: {
					authCheck: Json.authCheck,
				},
			});

		$('.form-check').on('click', (event: Event) => {
			if ($(event.currentTarget).hasClass('click')) {
				$(event.currentTarget).removeClass('active');
			} else {
				$(event.currentTarget).addClass('active');
				//關閉其他
				$(event.currentTarget).siblings().each(function () {
					$(event.currentTarget).removeClass('active');
				});
			}
		});
    }

}
